/**
 * DataLayer component that renders a Tilelayer with the passed url.
 */
import React, { PureComponent } from 'react';

import {
  TileLayer as LeafletTileLayer,
  LayerGroup as LeafletLayerGroup
} from 'react-leaflet';
import wrapDataLayer from './Utils/Wrapper';

import * as Constants from './Utils/Constants';
import LayerCreator from './Utils/LayerCreator';
import { bufferTiles, getClosestTimeSteps } from '../TimingHandler/TimingUtils';

let keyIndex = 0;

class TileLayer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.bufferLayer = false;
    this.tileLayers = [];
    this.zoomOffset = typeof props.zoomOffset !== 'undefined' ? props.zoomOffset : 0;
    this.tileSize = typeof props.tileSize !== 'undefined' ? props.tileSize : 256;
    this.createTileLayer = this.createTileLayer.bind(this);
    this.layerCreator = new LayerCreator(this.createTileLayer, 'big_tile_url');
  }

  componentWillMount() {
    const { props } = this;

    if (!props.timeConnected) {
      const currentTimestampIndex = getClosestTimeSteps(props.config.runs[0].timesteps, +new Date()).nearestTimestep.index || 0;
      const tileLayer = this.createTileLayer({
        url: `${Constants.TILE_HOST}${props.config.runs[0].timesteps[currentTimestampIndex].big_tile_url}`,
        opacity: props.opacity || 0.8
      });

      this.tileLayers = [tileLayer];

      return false;
    }

    this.bufferLayer = bufferTiles(
      props.config.runs[0].timesteps,
      props.leafletMap,
      'tileLayer',
      'big_tile_url',
      props.store,
      props.toggleLoadingApp
    );

    const initialValues = this.layerCreator.initLayers(props);
    this.tileLayers = initialValues.layers;
    this.currentIndex = initialValues.currentIndex;
  }

  componentWillUpdate(nextProps) {
    // when all tiles got buffered, we don't call bufferTiles func again
    if (!nextProps.timeConnected) {
      return false;
    }

    if (nextProps.tilesLoaded.every(t => t)) {
      return false;
    }

    // when user clicks on progress bar while buffering, we start buffering from that point
    if (this.props.currentTimestamp !== nextProps.currentTimestamp) {
      this.bufferLayer = bufferTiles(
        this.props.config.runs[0].timesteps,
        this.props.leafletMap,
        'tileLayer',
        'big_tile_url',
        this.props.store,
        this.props.toggleLoadingApp
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.currentTimestamp === this.props.currentTimestamp) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    if (this.bufferLayer) {
      this.bufferLayer.clearAllEventListeners();
    }
  }

  createTileLayer(props) {
    const key = props.url !== ' ' ? props.url : keyIndex++;
    return (<LeafletTileLayer
      tileSize={this.tileSize}
      zoomOffset={this.zoomOffset}
      opacity={typeof props.opacity === 'undefined' ? 0 : props.opacity}
      url={props.url}
      key={`TileLayer_${key}`}
    />);
  }

  render() {
    if (this.props.store) {
      const isPlaying = this.props.store.getState().TimingState.isPlaying;
      this.currentIndex = this.layerCreator.updateLayers(
        this.tileLayers, this.currentIndex, this.props, isPlaying
      );
    }

    return (
      <LeafletLayerGroup>
        {this.tileLayers}
      </LeafletLayerGroup>
    );
  }
}

TileLayer.propTypes = {
  beforeCount: React.PropTypes.number,
  afterCount: React.PropTypes.number,
  timeConnected: React.PropTypes.bool
};

TileLayer.defaultProps = {
  beforeCount: 2,
  afterCount: 2,
  timeConnected: false
};

export { TileLayer as TileLayerRaw };
export default wrapDataLayer(TileLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/TileLayer.js
 **/